<template>
  <div class="container">
    <h1 class="title">Referal Codes</h1>
    <h2 class="subtitle">
      Verwaltung der Referal Codes
    </h2>

    <div class="columns">
      <div class="column is-8"></div>

      <div class="column ">
        <div class="buttons buttons--end">
          <b-button
            icon-left="plus-circle"
            type="is-dark"
            @click="() => (ModalVisible = true)"
            >Neu</b-button
          >
        </div>
      </div>
    </div>

    <div class="modal-card" style="padding-bottom:3rem" v-if="ModalVisible">
      <div class="modal-card-head">
        <div class="modal-card-title">Referalcode anlegen</div>
      </div>
      <div class="modal-card-body" style="overflow-y:scroll !important;">
        <section>
          <b-field label="Name" horizontal>
            <b-input
              v-model="name"
              required
              lazy
              placeholder="Name des Referal Codes"
            ></b-input>
          </b-field>
          <b-field label="Code" horizontal>
            <b-input
              v-model="code"
              :lazy="true"
              required
              placeholder="Der Referalcode"
            ></b-input>
          </b-field>
        </section>
      </div>
      <footer class="modal-card-foot">
        <b-button type="is-text" @click="closeModal(null)" expanded
          >Abbrechen</b-button
        >
        <b-button type="is-primary" @click="newCode" expanded
          >Speichern</b-button
        >
      </footer>
    </div>

    <div class="columns">
      <div class="column">
        <b-field>
          <b-input
            placeholder="Suche..."
            icon="search"
            v-model="freeText"
            @keyup.enter.native="search"
          >
          </b-input>
        </b-field>
      </div>
    </div>

    <b-table
      :data="referals"
      paginated
      backend-pagination
      @page-change="pageChange"
      :total="total"
      :per-page="pageSize"
      striped
    >
      <template slot-scope="props">
        <b-table-column field="name" label="Name">{{
          props.row.name
        }}</b-table-column>
        <b-table-column field="code" label="Code"
          ><b-tag size="is-medium" class="is-italic"
            >{{ props.row.code }}
          </b-tag></b-table-column
        >
        <b-table-column field="disabled" label="Aktiv" centered>
          <span v-if="!props.row.disabled">Ja</span>
        </b-table-column>

      <b-table-column label="URL Zusatz">
            <emph>?r={{encodeURIComponent(props.row.code)}}</emph>
        </b-table-column>

        <b-table-column centered>
          <b-button
            :disabled="props.row.disabled"
            size="is-small"
            icon-left="trash"
            type="is-danger"
            @click="disableCode(props.row)"
            >Deaktivieren</b-button
          >
        </b-table-column>
        
  
      </template>
    </b-table>
  </div>
</template>
<script>
import referalApi from '@/api/referal-api'
export default {
  name: 'ReferalCodes',
  components: {},
  data() {
    return {
      ModalVisible: false,
      referals: [],
      page: 1,
      pageSize: 16,
      total: 0,
      freeText: '',
      name: '',
      code: '',
    }
  },
  async mounted() {
    await this.refreshData()
  },
  methods: {
    async refreshData() {
      const result = await referalApi.getReferalCodes(
        this.page,
        this.pageSize,
        'default',
        this.freeText,
        null,
      )
      this.referals = result.results
      this.page = result.page
      this.pageSize = result.pageSize
      this.total = result.total
    },
    showModal() {},
    closeModal() {
      this.ModalVisible = false
    },
    async pageChange(page) {
      this.page = page
      await this.refreshData()
    },
    async search() {
      await this.refreshData()
    },
    async disableCode(item) {
      await referalApi.disableReferal(item.id)
      item.disabled = true
      this.$buefy.toast.open('Deaktiviert!')
    },
    async newCode() {
      let name = this.name
      let code = this.code
      if (!name || name.length === 0) return
      if (!code || code.length === 0) return
      const item = await referalApi.createReferal(name, code)
      this.referals.push(item)
      this.$buefy.toast.open('Angelegt!')
      this.ModalVisible = false
    },
  },
}
</script>
